import { CountryCode } from "./types";
import { countries } from "./countries";

// Helper function to get initial country (defaults to US)
export const getDefaultCountry = (): CountryCode => {
  return (
    countries.find(
      ({ dial_code, code }) => dial_code === "+1" && code === "US"
    ) ||
    countries.find(({ dial_code }) => dial_code === "+1") ||
    countries[0]
  );
};

export const getFlagUrl = (countryCode: string) => {
  return `/flags/3x2/${countryCode.toUpperCase()}.svg`;
};
